import { CommandBar, ICommandBarProps } from "@fluentui/react";
import React from "react";
type ToolbarProps = ICommandBarProps

const Toolbar = (props: ToolbarProps) => {
  return (
    <CommandBar
      items={props.items}
      buttonAs={props.buttonAs}
      styles={props.styles}
      ariaLabel={props.ariaLabel}
      primaryGroupAriaLabel={props.primaryGroupAriaLabel}
      farItemsGroupAriaLabel={props.farItemsGroupAriaLabel}
    />
  );
};

export default Toolbar;
